<div class="flex flex-row w-full h-[75vh] baselayout-padding baselayout-padding-t items-stretch justify-between">
  <div class="flex flex-col w-[60%] h-full justify-around items-center ">
    <app-card-with-header>
      <div header></div>
      <div headerActions>
        @if (pageMode == 'view') {
          <p-button icon="pi pi-pen-to-square" [rounded]="true" (click)="enterEditMode()" />
        }
        @if (pageMode == 'edit') {
          <p-button icon="pi pi-save" [rounded]="true" (click)="saveTreatment()" />
        }
      </div>
      <div class="flex flex-col w-full h-full">
        @if (pageMode == 'view') {
          <div class="w-full h-[15vh]"></div>
          @if (treatment) {
            @if (treatment.description && treatment.description.length > 0) {
              <div [innerHTML]="treatment.description|safeHtml"></div>
            } @else {
              <div class="text-center">{{ 'TreatmentDetails.NoDescription'|translate }}</div>
            }
          }
        }
        @if (pageMode == 'edit') {
          <div>
            <div>
              <div class="mb-1">
                {{ 'TreatmentDetails.Title'|translate }}
              </div>
              <input id="name" type="text" variant="filled" fluid="true" pInputText pSize="large"
                     [invalid]="!treatment.title" [(ngModel)]="treatment.title" />
            </div>
            <div class="mt-3 mb-1">
              {{ 'TreatmentDetails.AppointmentDate'|translate }}
            </div>
            <p-datepicker id="appointmentDate" variant="filled" fluid="true" size="large" [(ngModel)]="treatmentDate"
                          showIcon iconDisplay="input" [showTime]="true" [stepMinute]="15" />
            <div class="mt-3 mb-1">
              {{ 'TreatmentDetails.Description'|translate }}
            </div>
            <p-editor [(ngModel)]="treatment.description" class="h-full">
              <ng-template #header>
                <span class="ql-formats">
                  <button type="button" class="ql-bold" aria-label="Bold"></button>
                  <button type="button" class="ql-italic" aria-label="Italic"></button>
                  <button type="button" class="ql-underline" aria-label="Underline"></button>
                  <button type="button" class="ql-strike" aria-label="Strike"></button>
                  <span class="ql-formats">
                    <select class="ql-color" aria-label="Color">
                      <option selected></option>
                      <option value="red"></option>
                      <option value="blue"></option>
                      <option value="yellow"></option>
                      <option value="white"></option>
                    </select>
                  </span>
                  <span class="ql-formats">
                    <select class="ql-size" aria-label="Size">
                      <option selected></option>
                      <option value="small"></option>
                      <option value="large"></option>
                      <option value="huge"></option>
                    </select>
                  </span>
                </span>
              </ng-template>
            </p-editor>
          </div>
        }
      </div>
    </app-card-with-header>
  </div>
  <div class="flex flex-col w-[30%] h-full justify-around items-center ">
    <app-attachment-gallery class="w-full h-full flex-shrink-0"
                            [pinnedDocuments]="pinnedDocuments"
                            [notPinnedDocuments]="notPinnedDocuments"
                            [pinnedImages]="pinnedImages"
                            [notPinnedImages]="notPinnedImages"
                            [pinnedTranslationKey]="'DocumentList.PinnedFromPet'"
                            [pinLock]="true"
                            [deletePinnedLock]="true"
                            [hasImages]="true"
                            [hasDocuments]="true"
                            (onDeleteDocument)="openDeleteDocumentDialog($event)"
                            (onViewDocument)="openViewDocumentDialog($event)"
                            (onAddDocument)="openAddDocumentDialog($event)"
                            (onEditDocument)="openEditDocumentPage($event)"
    ></app-attachment-gallery>
  </div>
</div>
